import { Skeleton, Typography } from "@mui/material";
import type React from "react";
import { Suspense } from "react";
import useDetail from "../../../../hooks/useDetail.ts";

const Name: React.FC<{ id: number }> = ({ id }) => {
	const detail = useDetail(id);

	const metaTitle = detail.data.name ?? "";

	return (
		<Typography
			variant="h1"
			sx={{
				fontSize: "1.3rem",
				marginTop: "1em",
				marginBottom: "0.5em",
				"@container ad-detail (max-width: 400px)": {
					fontSize: "1rem",
					marginTop: "1rem",
				},
			}}
			component="h1"
		>
			{metaTitle}
		</Typography>
	);
};

const AdName: React.FC<{ id: number }> = ({ id }) => {
	return (
		<Suspense fallback={<Skeleton />}>
			<Name id={id} />
		</Suspense>
	);
};

export default AdName;
